<template>
  <div class="bar-content find-pasw">
    <div class="find-content">
      <p class="title">Don't fret! Just reset your password</p>
      <p class="desc">Please enter your e-mail address and we'll send you a code to reset a new password</p>
      <div class="form">
        <Nav only />
        <Input v-model="email" label="Email">
          <div slot="bottom" class="error-box">
            <span v-show="emailError">{{ emailError }}</span>
          </div>
        </Input>
        <InputWrap v-if="captchaImage" v-model="code" label="Verification code">
          <div class="img-code">
            <i-input v-model="imgCode" class="img-input" />
            <div class="img-wrap">
              <img :src="captchaImage" @click="getImage" />
              <i-spin v-if="codeLoading" fix>
                <i-icon type="ios-loading" size="40" class="spin-icon-load" />
              </i-spin>
            </div>
          </div>
        </InputWrap>
        <Input v-show="visibleEmail" v-model="code" label="Email code">
          <div slot="bottom" class="error-box"></div>
        </Input>
        <div class="btn-box" @click="getCode">
          <Button :loading="loading">Continue</Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Nav from '../../components/comm/Nav';
import Input from '../../components/input/Input';
import InputWrap from '../../components/input/InputWrap';
import Button from '../../components/button/Button';
import { API } from '../../net/http';

const FIND_TYPES = {
  INIT: 'init',
  GET_CODE: 'get_img_code',
  CHECK_IMG_CODE: 'check_img_code',
  CHECK_MAL_CODE: 'check_mal_code',
};

const ClientTicket = 'Client-Ticket';

export default {
  components: {
    Nav,
    Input,
    Button,
    InputWrap,
  },
  data() {
    return {
      email: '',
      code: '',
      visibleEmail: false,
      loading: false,
      captchaImage: '',
      imgCode: '',
      codeLoading: false,
      emailError: '',
      findType: FIND_TYPES.INIT,
    };
  },
  mounted() {
    this._clientTicket = '';
    this.findType = FIND_TYPES.INIT;
    let email = this.$route.query.email;
    if (email) {
      this.email = email;
    }
  },
  methods: {
    getCode() {
      this.loading = true;
      API.authForget.format = false;
      let headers = {};
      if (this.findType === FIND_TYPES.CHECK_MAL_CODE) {
        return this.validationCode();
      } else if (this.findType === FIND_TYPES.CHECK_IMG_CODE) {
        API.authForget.format = true;
        API.authForget.query = {
          'check-captcha-image': this.imgCode,
        };
        headers[ClientTicket] = this._clientTicket;
      }
      this.$post(
        API.authForget,
        {
          'check-captcha-image': this.imgCode,
          mail: this.email,
          [ClientTicket]: this._clientTicket,
        },
        headers,
      )
        .then(res => {
          if (res.success) {
            this.loading = false;
            this.visibleEmail = true;
            this.findType = FIND_TYPES.CHECK_MAL_CODE;
            this.$Message.success({
              content: res.message,
              duration: 3,
            });
          } else if (res.response && res.response.status === 406) {
            this.findType = FIND_TYPES.CHECK_CODE;
            this._clientTicket = res.response.headers[ClientTicket];
            this.getImage();
          } else {
            this.findType === FIND_TYPES.INIT;
            this.loading = false;
            this.$Message.error(res.message);
          }
        })
        .catch(e => {
          console.log(e);
          this.findType === FIND_TYPES.INIT;
          this.loading = false;
        });
    },
    getImage() {
      if (this.codeLoading) {
        return;
      }
      this.codeLoading = true;
      API.authForget.format = true;
      API.authForget.query = { 'quest-captcha-image': Date.now() };
      this.$post(
        API.authForget,
        {},
        {
          [ClientTicket]: this._clientTicket,
          Accept: 'text/base64',
        },
      )
        .then(res => {
          this.loading = false;
          this.codeLoading = false;
          if (res) {
            this.captchaImage = res;
            this.findType = FIND_TYPES.CHECK_IMG_CODE;
          } else {
            this.$Message.error({
              content: 'need a captcha',
              duration: 3,
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.codeLoading = false;
          this.$Message.error({
            content: error.message,
            duration: 3,
          });
          return Promise.reject(error);
        });
    },
    validationCode() {
      this.loading = true;
      this.$post(API.authCheckEmailCode, {
        mail: this.email,
        code: this.code,
      })
        .then(res => {
          this.loading = false;
          if (res.success) {
            this.$router.push({
              name: 'change-password',
              params: {
                mail: this.email,
                code: this.code,
              },
            });
          } else {
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import '../../assets/fonts/font.less';
@import '../../assets/css/main.less';
.find-pasw {
  background-color: #fff;
  padding-bottom: 40px;
  .find-content {
    width: 336px;
    margin: 0px auto;
    .title {
      .font-regular;
      margin-top: 126px;
      font-size: 18px;
      font-weight: 400;
      color: #262626;
      line-height: 24px;
    }
    .desc {
      .font-light;
      padding-top: 10px;
      font-size: 12px;
      font-weight: 300;
      padding-top: 10px;
      color: @app-black-color;
    }
    .form {
      margin-top: 46px;
      .btn-box {
        width: 296px;
        margin: 26px auto 0;
      }
      .error-box {
        .font-light;
        padding-top: 10px;
        color: @app-error-color;
        font-size: 14px;
        font-weight: 300;
      }
      .img-code {
        display: flex;
        flex-direction: row;
        align-items: center;
        img {
          height: 46px;
          margin-left: 18px;
        }
        .img-input {
          flex: 1;
        }
        .img-wrap {
          width: 132px;
          height: 46px;
          position: relative;
        }
      }
    }
  }
}
</style>
